// Formats a point in degrees, minutes and seconds: "50°43′28″N · 4°51′29″E".
const dms = (value: number, positive: string, negative: string): string => {
  const hemisphere = value < 0 ? negative : positive;
  let totalSeconds = Math.round(Math.abs(value) * 3600);
  const degrees = Math.floor(totalSeconds / 3600);
  totalSeconds -= degrees * 3600;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds - minutes * 60;
  return `${degrees}°${minutes}′${seconds}″${hemisphere}`;
};

export function formatCoordinates(lat: number, lng: number): string {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return '';
  return `${dms(lat, 'N', 'S')} · ${dms(lng, 'E', 'W')}`;
}
